<template>
    <el-dialog
  title="提示"
  :visible.sync="dialogMsg.dialogKeyWorlds"
  width="30%"
  :before-close="addKeyBack">
  <el-row :gutter="20">
  <el-col :span="12">
    <div class="grid-content bg-purple">
    <el-input v-model="addMsg.name" placeholder="请输入中文关键字">
          </el-input>
    </div>
    </el-col>
  <el-col :span="12">
    <div class="grid-content bg-purple">
    <el-input v-model="addMsg.englishName" placeholder="请输入英文关键字">
          </el-input>
    </div>
    </el-col>
  
</el-row>
   <span slot="footer" class="dialog-footer">
    <el-button @click="addKeyBack">取 消</el-button>
    <el-button type="primary" @click="addKeyOK">确 定</el-button>
  </span>
</el-dialog>
</template>
<script>
export default {
    props:{dialogMsg:Object},
    data() {
      return {
        addMsg:{}
      }
    },
    methods: {
         handleClose() {
              this.$emit("addKeyBack", false);
         },
    addKeyBack() {
      this.$emit("addKeyBack", false);
      this.addMsg={}
    },
    addKeyOK() {
        this.$emit("addKeyOK",this.addMsg)
        this.addMsg={}
    },
    },
}
</script>
<style lang="scss" scoped>
.el-dialog__footer {
    padding: 10px 25% 20px;
    .dialog-footer {
      height: 28px;
      display: flex;
      justify-content: center;
      .el-button--default:hover {
        background: $base-color;
        color: $blueBtna;
      }
      .el-button--default {
        border-radius: 100px;
        border: 1px solid $schoolTagBorder;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $schoolTagColor;
        }
      }
      .el-button--primary {
        border-radius: 100px;
        background: $pageViewSmall;
        border: 1px solid $pageViewSmall;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $base-color;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/admin/exploration/components/DialogKeyWorlds.vue